import { render, staticRenderFns } from "./AlegereSaTeImplici.vue?vue&type=template&id=2dcdff23&scoped=true&"
import script from "./AlegereSaTeImplici.ts?vue&type=script&lang=ts&"
export * from "./AlegereSaTeImplici.ts?vue&type=script&lang=ts&"
import style0 from "./AlegereSaTeImplici.vue?vue&type=style&index=0&id=2dcdff23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdff23",
  null
  
)

export default component.exports